import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import AdSenseBanner, {
    ADSENSE_CLIENT,
    ADSENSE_ENABLED,
    ADSENSE_SLOT_WEB_HORIZONTAL,
} from "../../../pages/components/AdSenseBanner";

function readFillSnapshot() {
    const el = document.querySelector(".pi-ad-banner ins.adsbygoogle");
    if (!el) {
        return { present: false };
    }
    const iframe = el.querySelector("iframe");
    return {
        present: true,
        status: el.getAttribute("data-adsbygoogle-status") || "(none)",
        adStatus: el.getAttribute("data-ad-status") || "(none)",
        insW: el.offsetWidth,
        insH: el.offsetHeight,
        iframeCount: el.querySelectorAll("iframe").length,
        iframeW: iframe?.offsetWidth ?? 0,
        iframeH: iframe?.offsetHeight ?? 0,
        iframeSrc: (iframe?.src || "").slice(0, 160),
    };
}

export default function AdSenseTestMain() {
    const navigate = useNavigate();
    const [fill, setFill] = useState(() => ({ present: false }));

    useEffect(() => {
        const tick = () => setFill(readFillSnapshot());
        tick();
        const id = window.setInterval(tick, 500);
        return () => window.clearInterval(id);
    }, []);

    return (
        <Box sx={{ p: 2, maxWidth: 1180, mx: "auto" }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/admin/system/anything")}
                sx={{ mb: 2, minHeight: 44, textTransform: "none" }}
            >
                Anything
            </Button>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
                Google AdSense test
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Site-wide ads stay off (`ADSENSE_ENABLED` is {String(ADSENSE_ENABLED)}).
                This page forces the live unit. Client {ADSENSE_CLIENT}, slot{" "}
                {ADSENSE_SLOT_WEB_HORIZONTAL}. Localhost sends `data-adtest=on`.
            </Typography>
            <Paper variant="outlined" sx={{ p: 2, mb: 2, bgcolor: "grey.50" }}>
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                    Fill status
                </Typography>
                {!fill.present ? (
                    <Typography variant="body2">Waiting for the AdSense unit…</Typography>
                ) : (
                    <Typography variant="body2" component="div" sx={{ fontFamily: "monospace", fontSize: 13 }}>
                        status={fill.status} · data-ad-status={fill.adStatus} · ins={fill.insW}×{fill.insH} · iframes={fill.iframeCount}
                        {fill.iframeCount > 0
                            ? ` · iframe=${fill.iframeW}×${fill.iframeH}`
                            : ""}
                        {fill.iframeSrc ? ` · ${fill.iframeSrc}` : ""}
                    </Typography>
                )}
                <Typography variant="body2" sx={{ mt: 1 }}>
                    Google is answering the ad request (iframe from doubleclick), but the
                    creative is empty — that is why the slot looks blank. This page hides that
                    white iframe and shows a dark label instead. A real banner will replace it
                    when AdSense is Ready and Google actually fills the unit.
                </Typography>
            </Paper>
            <AdSenseBanner variant="page" force debug />
        </Box>
    );
}
